import {Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
  UntypedFormGroup, ValidationErrors,
  Validators
} from "@angular/forms";
import {pairwise, startWith} from "rxjs/operators";
import {Subscription} from "rxjs";
import {BackendApiService} from "../../../../../services/backend-api.service";
import {AppConstants} from "./../../../../../constants/app.constants";

@Component({
    selector: 'app-drawing',
    templateUrl: './drawing.component.html',
    styleUrls: ['./drawing.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DrawingComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DrawingComponent),
            multi: true
        }
    ],
    standalone: false
})
export class DrawingComponent implements OnInit {
  // @ts-ignore
  @ViewChild(DrawingComponent,{static: true}) DrawingComponent: DrawingComponent;
  @Input() model: any = {};
  @Input() form: any = {};
  @Input() isEdit : boolean = false;
  @Output() callback = new EventEmitter<any>(true);
  @Output() onInitForm = new EventEmitter<any>(true);
  changeOrderModuleId =  5;
  public drawingForm: UntypedFormGroup = this.initFormDrawing();
  public typeList:any = [
    {id:1,name:'Type Demo'},
  ];
  public appConstants
  // @ts-ignore
  private drawingSubscription: Subscription;
  constructor(
    public backendApiService: BackendApiService,
  ) {
  this.appConstants = AppConstants;
  }

  ngOnInit(): void {
    this.initSubscriptions();
  }
  initFormDrawing(value: any = null){
    return new UntypedFormGroup({
      date: new UntypedFormControl(null,[]),
      type: new UntypedFormControl(null,[]),
      number: new UntypedFormControl(null,[]),
      file: new UntypedFormControl(null,value ? [] : []),

    });
    this.onInitForm.emit(this.drawingForm);
    return this.drawingForm;
  }

  attachmentId(event: any) {
    console.log('event',event);
    const data  = event?.attachment;
    // console.log('arar',data);
    this.drawingForm.get('file')?.setValue(data?.attachment_id);

    // console.log(this.additionalInfo.get('file')?.value);
  }
  initSubscriptions(){
    // @ts-ignore
    this.drawingForm.get('date').updateValueAndValidity({ onlySelf: false, emitEvent: true });
    this.drawingSubscription = this.form.valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        if (this.form.touched){
          this.touchFormControls();
        }
        // console.log(this.additionalInfo);
      });
  }
  touchFormControls(){
    Object.keys(this.drawingForm.controls).forEach(key => {
      this.drawingForm.get(key)?.markAsTouched();
    });
  }


  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.drawingForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.drawingForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.drawingForm.disable() : this.drawingForm.enable();
  }
  validate(c: AbstractControl): ValidationErrors | null{
    return this.drawingForm.valid ? null : { invalidForm: {valid: false, message: "additionalInfo  fields are invalid"}};
  }
  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.drawingSubscription.unsubscribe();
  }
}
